import React from "react";
import styled from "@emotion/styled";
import QRCode from "qrcode.react";
import { Link } from "gatsby";

const Section = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const Back = styled.div`
  padding-left: 1em;
`;

const Wrap = styled.div`
  display: flex;
  flex-direction: row;
`;

const PlayIdFont = styled.div`
  font-size: 18px;
  padding-left: 1em;
  font-weight: bold;
  color: white;
`;

const Nama = styled.h3`
  font-family: ${props => props.theme.fonts.subheading};
  font-weight: bold;
  text-transform: uppercase;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
  width: 100%;
`;

const QRContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 15px;
`;

const QRSection = styled.div`
  width: 320px;
  height: 300px;
  background: white;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
  margin-bottom: 30px;
  @media (max-width: 350px) {
    width: 290px;
  }
`;
const QRWrapper = styled.div`
  margin: 15px;
`;
const Desc = styled.div`
  color: black;
  font-size: 14px;
  font-weight: bold;
`;

export default function PlayIdCard(props) {
  return (
    <Section {...props}>
      <Link to="/play">
        <Wrap>
          <Back>
            <svg
              width="15"
              height="26"
              viewBox="0 0 15 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.9932 1.47998L2.48001 12.9886L12.9895 24.4581"
                stroke="white"
                stroke-width="2"
              />
            </svg>
          </Back>
          <PlayIdFont>PLAY ID</PlayIdFont>
        </Wrap>
      </Link>
      <Nama>{props.playerName}</Nama>
      <QRContainer>
        <QRSection>
          {/* <Desc>Tap to Enlarge</Desc> */}
          <QRWrapper>
            <QRCode value={props.myId} size={200} level="H" />
          </QRWrapper>
          <Desc>Show this code to our tenants to get points</Desc>
        </QRSection>
      </QRContainer>
    </Section>
  );
}

PlayIdCard.defaultProps = {
  playerName: "Jonathan Filbert"
};
